import React, { useEffect, useState } from 'react';
import './ProviderItemOrderDetail.scss';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TableHead from '@material-ui/core/TableHead';
import { TableFooter, Button } from '@material-ui/core';
import { FxCurrency, http, general, formatService, AlertService } from '../../fx-core';
import _ from "lodash";
import Dialog from '@material-ui/core/Dialog';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';

const ProviderItemOrderDetail = (props: any) => {
  console.log("provider item order detail props", props);
  const initialList = [];
  let defaultOrder = {
    orderIdentifier: null,
    orderDate: null,
    orderTypeId: 0,
    stallName: null,
    deliveryCharge: 0,
    orderTotal: 0,
    stallAddress: null,
    consumerName: '',
    consumerPhone: '',
    orderStatusId: 0,
    couponAmount: 0,
    orderAmount: 0,
    placedDate: null,
    riderName: null,
    riderContact: null,
    statusCode: null,
    partnerName: null,
  }
  let defaultAddress = {
    fullAddress: null,
    fullName: null,
    locationName:null
  }

  let defaultSlot = {
    description: null,
    startTime: null,
    endTime: null
  }
  let defaultContex = {
    isShowCoupon: false,
    couponApplied: 0,
    balanceToPay: 0
  };
  let selOrderDefaultObj = {
    id: 0,
    orderStatusId: 0,
    orderTypeId: 0,
    taskId: 0
  };
  const [order, setOrder] = useState(defaultOrder);
  const [orderLines, setOrderLines] = useState(initialList);
  const [address, setAddress] = useState(defaultAddress);
  const [orderPayments, setOrderPayments] = useState(initialList);
  const [deliverySlot, setDeliverySlot] = useState(defaultSlot);
  const [currentContext, setCurrentContext] = useState(defaultContex);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(selOrderDefaultObj);
  const [isCancelAction, setIsCancelAction] = useState(false);
  const [deliveryPartnerStatus, setDeliveryPartnerStatus] = useState(null);
  const [stall, setStall] = useState(null);
  const [uengageId, setUengageId] = useState(null);



 

  const getOrderDetail = () => {
    console.log("Fetching order details for order ID:", props.orderId);
    let inputData = {
      id: props.orderId
    };

    let apiOptions: any = {
      url: `order/detail/${inputData.id}`
    };
    http.get(apiOptions).then(res => {
      getOrderDetailCallBack(res)
    });
  };

  const getOrderDetailCallBack = (res) => {
    console.log("order detail response", res.data);

    let result = res.data;
    let deliverySlotData: any = {};
    let orderLinesData: any = [];
    for (let item of result) {
      setOrder(item.order);
      setAddress(item.address);
      setOrderPayments(item.orderPayments);
      deliverySlotData = item.deliverySlot;
      orderLinesData = item.orderLines;
      


      if(item.order.stallId){ 
        getStallById(item.order.stallId);
      }

     // Fetch delivery partner status if taskId exists
      if (item.order.taskId && item.order.orderStatusId != 6) {
        fetchDeliveryPartnerStatus(item.order.taskId, item.order.stallId);
      }
    }
    setDeliverySlot(deliverySlotData);

    for (let item of orderLinesData) {
      item.imageUrl = general.getImageUrl(item.imagePath);
      item.orderLineModifiers = _.map((_.groupBy(item.orderLineModifiers, function (i) {
        return i.groupName
      })), function (items, key) { return { key: key, displayModifiers: items }; });
    }
    setOrderLines(orderLinesData);
  };

  const fetchDeliveryPartnerStatus = (taskId) => {
    const apiOptions = {
      url: 'order/trackTaskStatus',
      data: {
        storeId:uengageId, //uengageId,// test 89
        taskId: taskId
      }
    };
    
    http.post(apiOptions).then(res => {
      if (res.data && res.data.status) {
        setDeliveryPartnerStatus(res.data.status);
        console.log("Delivery partner status:", res.data);
      }
    }).catch(error => {
      console.error("Error fetching delivery partner status:", error);
    });
  };

   const getStallById = (stallId) => {
    let apiOptions: any = {
      url: `stall/${stallId}`
    };
    http.get(apiOptions).then(res => {
      getStallCallBack(res.data);
    })
  };

  const getStallCallBack = (res) => {
    setStall(res);
    setUengageId(res.uengageId);
    console.log("stall data", res);
  };


  
  const handleClose = () => {
    props.handleClose();
  };

  const defaulConfirmDialogStateValues = () => {
    setSelectedOrder(selOrderDefaultObj);
    setMessage(null);
    setConfirmOpen(false);
    if (isCancelAction) {
      setIsCancelAction(false);
    }
  };

  const openConfirmDialogByStatus = (item) => {
    let msg: any = "";
    if (item.orderStatusId === 1) {
      msg = "Do you want to accept the order #" + item.orderIdentifier + "?";
    }
    else if (item.orderStatusId === 2 && item.orderTypeId === 1) {
      msg = "Do you want to ship the order #" + item.orderIdentifier + "?";
    }
    else if (item.orderStatusId === 2 && item.orderTypeId === 2) {
      msg = "Is the order #" + item.orderIdentifier + " ready?";
    }
    else if (item.orderStatusId === 4 || item.orderStatusId === 5) {
      msg = "Do you want to deliver the order #" + item.orderIdentifier + "?";
    }
    setSelectedOrder(item);
    setMessage(msg);
    setConfirmOpen(true);
  };

  const handleDialogClose = () => {
    defaulConfirmDialogStateValues()
  };

  const onConfirmCallback = (action, comments) => {
    if (selectedOrder.orderStatusId === 1) {
      if (action === 'cancel') {
        cancelOrder(comments);
           setTimeout(() => {
                          AlertService.showSuccessMsg("Order cancelled")
        
                }, 1000);
      } else {
        markAsAccepted();
      }
    }
    else if (selectedOrder.orderStatusId === 2) {
      markAsReadyOrShipped();
    }
    else if (selectedOrder.orderStatusId === 4 || selectedOrder.orderStatusId === 5) {
      markOrderDelivered();
    }
  };

  const markAsAccepted = () => {
    let apiOptions = {
      url: `order/${selectedOrder.id}/markAsAccepted`
    };
    http.put(apiOptions).then(res => {
      markAsAcceptedCallBack(res);
    });
  };

  const markAsAcceptedCallBack = (res) => {
    AlertService.showMsg({ message: "Order is accepted" });
    defaulConfirmDialogStateValues();
    getOrderDetail();
  };

  const markAsReadyOrShipped = () => {
    let apiOptions = {
      url: `order/${selectedOrder.id}/MarkAsReadyOrShipped`
    };
    http.put(apiOptions).then(res => {
      markAsReadyOrShippedCallBack(res);
    });
  };

  const markAsReadyOrShippedCallBack = (res) => {
    let successMsg = "";
    if (selectedOrder.orderTypeId === 1) {
      successMsg = "Order shipped";
    }
    else if (selectedOrder.orderTypeId === 2) {
      successMsg = "Order ready";
    }
    AlertService.showMsg({ message: successMsg });
    defaulConfirmDialogStateValues();
    getOrderDetail();
  };

  const markOrderDelivered = () => {
    let inputData = {
      id: selectedOrder.id,
      currentDate: formatService.getCurrentDateForServer()
    }
    let apiOptions = {
      url: `order/MarkOrderDelivered`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      markOrderDeliveredCallBack(res);
    });
  };

  const markOrderDeliveredCallBack = (res) => {
    AlertService.showMsg({ message: "Order delivered" });
    defaulConfirmDialogStateValues();
    getOrderDetail();
  };

  const openConfirmDialogForCancel = (item) => {
    setSelectedOrder(item);
    setIsCancelAction(true);
    setConfirmOpen(true);
  };

  const cancelOrder = (comments) => {
    let inputData = {
      id: selectedOrder.id,
      cancelledRemarks: comments
    }
    let apiOptions = {
      url: `order/MarkOrderCancelled`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      cancelOrderCallBack(res);
    });
  };

  const cancelOrderCallBack = (res) => {
    defaulConfirmDialogStateValues();
    console.log("cancel order response", res);
    getOrderDetail();
    //   if(selectedOrder?.taskId != undefined || selectedOrder.taskId != 0){
    //   cancelTask(selectedOrder);
    // }
  };

  const cancelTask = () => {
  let inputData = {
    storeId:uengageId, // Use uengageId if available, otherwise hardcoded for now//89
    taskId: selectedOrder?.taskId,
    orderId: selectedOrder?.id,
  }
  console.log("Cancelling task with data:", inputData);
  
  let apiOptions = {
    url: `order/cancelTask`,
    data: inputData
  };
  
  http.post(apiOptions).then(res => {
    console.log("Task cancelled successfully:", res.data);
  }).catch(error => {
    console.error("Error cancelling task:", error);
  });
};
  useEffect(() => {
    getOrderDetail();
  }, []);

  const body = (
    <div className='provider-item-order-detail'>
      <div className="row col-12 title-font py-1 mx-auto">
        <div className="col-11 pl-0">
          <span>Order Detail</span>
        </div>
        <div className="col-1 text-right pointer my-auto pr-2">
          <i className="fas fa-times-circle font-16" onClick={handleClose}></i>
        </div>
      </div>

      {/* Desktop View */}
      <div className='deskview'>
        <div className='row mr-3 my-3 ml-0'>
          <div className='col-7'>
            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
              <Table className="table-striped" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell >Items</TableCell>
                    <TableCell width={25} >Qty</TableCell>
                    <TableCell align="right" >Price</TableCell>
                    <TableCell width={100} align="right" >Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderLines.map((row: any) => (
                    <TableRow key={row.id}>
                      <TableCell className="font-12">
                        {row.itemName}
                        <div className='font-11 extras-txt'>
                          {row.orderLineModifiers && row.orderLineModifiers.map((custom, i) => (
                            <div>
                              <span>{custom.key}-</span>
                              {custom.displayModifiers && custom.displayModifiers.map((detail, idx) => (
                                <span>{detail.description}
                                  {idx != (custom.displayModifiers.length - 1) &&
                                    <span>, </span>
                                  }
                                  {i != (row.orderLineModifiers.length - 1) &&
                                    <span>, </span>
                                  }
                                </span>
                              ))}
                            </div>
                          ))}
                        </div>
                      </TableCell>
                      <TableCell className="table-font">
                        <span>{row.itemQuantity}</span>
                      </TableCell>
                      <TableCell align="right">
                        <span className="table-font">
                          {row.itemQuantity} * <FxCurrency value={row.price} />
                          {row.lineModifierAmount > 0 &&
                            <span>+ <FxCurrency value={row.lineModifierAmount} /></span>
                          }
                        </span>
                      </TableCell>
                      <TableCell align="right">
                        <span className="table-font">
                          <FxCurrency value={row.lineTotalPrice} />
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell align="right" colSpan={3}>
                      <span className="table-font">Order Amount</span>
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.orderAmount} />
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="right" colSpan={3}>
                      <span className="table-font">Coupon Amount</span>
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.couponAmount} />
                      </span>
                    </TableCell>
                  </TableRow>
                  {
                    order.orderTypeId == 1 &&
                    <TableRow>
                      <TableCell align="right" colSpan={3}>
                        <span className="table-font">Delivery Charge</span>
                      </TableCell>
                      <TableCell align="right">
                        <span className="table-font">
                          <FxCurrency value={order.deliveryCharge} />
                        </span>
                      </TableCell>
                    </TableRow>
                  }
                  <TableRow>
                    <TableCell align="right" colSpan={3}>
                      {
                        order.orderTypeId == 1 &&
                        <span className="table-font">Total((Order Amount - Coupon Amount) + Delivery Charge)</span>
                      }
                      {
                        order.orderTypeId == 2 &&
                        <span className="table-font">Total(Order Amount - Coupon Amount)</span>
                      }
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.orderTotal} />
                      </span>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>

          <div className='col-5 summary-detail font-14'>
            <div className='row'>
              <div className='col-4'>Order #</div>
              <div className='col-8'>: {order.orderIdentifier}</div>
            </div>
            <div className='row pt-1'>
              <div className='col-4'>Ordered Date</div>
              <div className='col-8'>: {general.getFormattedDate(order.placedDate)}</div>
            </div>
            <div className='row pt-1'>
              <div className='col-4'>Consumer</div>
              <div className='col-8'>
                <span className='pl-1'>{order.consumerName}</span>
                <span className='pl-3'>{order.consumerPhone}</span>
              </div>
            </div>
              <div className='row pt-1'>
              <div className='col-4'>Community</div>
              <div className='col-8'>
                <span className='pl-1'>{order.communityName}</span>
              </div>
            </div>
            {
              order.isLoyaltyOrder === true &&
              <div className='row pt-1'>
                <div className='col-4'>Order Type</div>
                <div className='col-8'>: Loyalty</div>  
              </div>

              
            }
            {orderPayments.map((item: any) => (
              <div>
                <div className='row pt-1'>
                  <div className='col-4'>
                    {item.paymentMode != 'coupon' &&
                      <span>Order total</span>
                    }
                    {item.paymentMode == 'coupon' &&
                      <span>Coupon Value</span>
                    }
                  </div>
                  <div className='col-8'>: <FxCurrency value={item.amount} /></div>
                </div>
                <div className='row pt-1'>
                  <div className='col-4'>Payment Mode</div>
                  <div className='col-8'>
                    <span>: </span>
                    <span>
                      {item.paymentMode == 'cod' &&
                        <span className="pr-1">Cash</span>
                      }
                      {item.paymentMode == 'stripe' &&
                        <span className="pr-1">Card</span>
                      }
                      {item.paymentMode != 'stripe' && item.paymentMode != 'cod' &&
                        <span className="pr-1 payment-style">{item.paymentMode}</span>
                      }
                    </span>
                  </div>
                </div>
                <div className='row pt-1'>
                  <div className='col-4'>
                    {item.paymentMode != 'coupon' &&
                      <span>Payment Status</span>
                    }
                    {item.paymentMode == 'coupon' &&
                      <span>Discount Status</span>
                    }
                  </div>
                  <div className='col-8'>
                    : <span>{item.paymentStatus}</span>
                  </div>
                </div>
              </div>
            ))}
            {deliverySlot &&
              <div className='row pt-1'>
                <div className='col-4'>
                  {order.orderTypeId === 1 &&
                    <span>Delivery</span>
                  }
                  {order.orderTypeId === 2 &&
                    <span>Pickup</span>
                  }
                </div>
                <div className='col-8'>: 
                  <span className='mr-2'> {general.getFormattedDate(order.orderDate)}</span>
                  {general.getFormattedTime(deliverySlot.startTime)} - {general.getFormattedTime(deliverySlot.endTime)}
                </div>
              </div>
            }
            {order.orderTypeId === 1 &&
              <div className='row pt-1'>
                <div className='col-4'>Delivery Address</div>
                <div className='col-8'>: {address.fullAddress}</div>
                <div className='col-4'>Location</div>
                {
                  address.locationName && 
                  <div className='col-8'>: {address.locationName ? address.locationName : ""}</div>
                }
              </div>
            }
            {order.orderTypeId === 2 &&
              <div className='row pt-1'>
                <div className='col-4'>Pickup Address</div>
                <div className='col-8'>: {order.stallAddress}</div>
              </div>
            }
            

              {order.orderTypeId === 1 && order.partnerName && (
              <div className='row pt-1'>
                <div className='col-4'>Partner Name</div>
                <div className='col-8'>: {order.partnerName}</div>
              </div>
            )}
            {/* Delivery Partner Information */}
            {order.orderTypeId === 1 && order.riderName && (
              <div className='row pt-1'>
                <div className='col-4'>Rider Name</div>
                <div className='col-8'>: {order.riderName}</div>
              </div>
            )}
            
            {order.orderTypeId === 1 && order.riderContact && (
              <div className='row pt-1'>
                <div className='col-4'>Partner Contact</div>
                <div className='col-8'>: {order.riderContact}</div>
              </div>
            )}
            
            {order.orderTypeId === 1 && order.statusCode && (
              <div className='row pt-1'>
                <div className='col-4'>Order Status</div>
                <div className='col-8'>: {order.statusCode}</div>
              </div>
            )}
            
            {/* {order.orderTypeId === 1 && deliveryPartnerStatus && (
              <div className='row pt-1'>
                <div className='col-4'>Delivery Status</div>
                <div className='col-8'>: {deliveryPartnerStatus}</div>
              </div>
            )} */}
          </div>
          <div className='col-12 text-right pt-2'>
            {
              order.orderStatusId === 1 &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Accept</Button>
            }
            {
              (order.orderStatusId === 2 && order.orderTypeId === 1) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Ship</Button>
            }
            {
              (order.orderStatusId === 2 && order.orderTypeId === 2) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Ready</Button>
            }
            {
              (order.orderStatusId === 4 || order.orderStatusId === 5) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Deliver</Button>
            }
            {
              order.orderStatusId === 1 &&
              <Button variant='outlined' size='small' className='button-style ml-2' onClick={() => openConfirmDialogForCancel(order)}>Cancel</Button>
            }
          </div>
        </div>
      </div>

      {/* Tablet View */}
      <div className='tabview'>
        <div className='row mr-3 my-3 ml-0'>
          <div className='col-7'>
            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
              <Table className="table-striped" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell >Items</TableCell>
                    <TableCell width={25}>Qty</TableCell>
                    <TableCell align="right" >Price</TableCell>
                    <TableCell width={100} align="right" >Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderLines.map((row: any) => (
                    <TableRow key={row.id}>
                      <TableCell className="table-font">
                        {row.itemName}
                        <div className='font-11 extras-txt'>
                          {row.orderLineModifiers && row.orderLineModifiers.map((custom, i) => (
                            <div>
                              <span>{custom.key}-</span>
                              {custom.displayModifiers && custom.displayModifiers.map((detail, idx) => (
                                <span>{detail.description}
                                  {idx != (custom.displayModifiers.length - 1) &&
                                    <span>, </span>
                                  }
                                  {i != (row.orderLineModifiers.length - 1) &&
                                    <span>, </span>
                                  }
                                </span>
                              ))}
                            </div>
                          ))}
                        </div>
                      </TableCell>
                      <TableCell className="table-font">
                        <span>{row.itemQuantity}</span>
                      </TableCell>
                      <TableCell align="right">
                        <span className="table-font">
                          {row.itemQuantity} * <FxCurrency value={row.price} />
                          {row.lineModifierAmount > 0 &&
                            <span>+ <FxCurrency value={row.lineModifierAmount} /></span>
                          }
                        </span>
                      </TableCell>
                      <TableCell align="right">
                        <span className="table-font">
                          <FxCurrency value={row.lineTotalPrice} />
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell align="right" colSpan={3}>
                      <span className="table-font">Order Amount</span>
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.orderAmount} />
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="right" colSpan={3}>
                      <span className="table-font">Coupon Amount</span>
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.couponAmount} />
                      </span>
                    </TableCell>
                  </TableRow>
                  {
                    order.orderTypeId == 1 &&
                    <TableRow>
                      <TableCell align="right" colSpan={3}>
                        <span className="table-font">Delivery Charge</span>
                      </TableCell>
                      <TableCell align="right">
                        <span className="table-font">
                          <FxCurrency value={order.deliveryCharge} />
                        </span>
                      </TableCell>
                    </TableRow>
                  }
                  <TableRow>
                    <TableCell align="right" colSpan={3}>
                      {
                        order.orderTypeId == 1 &&
                        <span className="table-font">Total((Order Amount - Coupon Amount) + Delivery Charge)</span>
                      }
                      {
                        order.orderTypeId == 2 &&
                        <span className="table-font">Total(Order Amount - Coupon Amount)</span>
                      }
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.orderTotal} />
                      </span>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>

          <div className='col-5 summary-detail font-14'>
            <div className='row'>
              <div className='col-4'>Order #</div>
              <div className='col-8'>: {order.orderIdentifier}</div>
            </div>
            <div className='row pt-1'>
              <div className='col-4'>Ordered Date</div>
              <div className='col-8'>: {general.getFormattedDate(order.placedDate)}</div>
            </div>
            <div className='row pt-1'>
              <div className='col-4'>Consumer</div>
              <div className='col-8'>:
                <span className='pl-1'>{order.consumerName}</span>
                <span className='pl-3'>{order.consumerPhone}</span>
              </div>
            </div>
               <div className='row pt-1'>
              <div className='col-4'>Community</div>
              <div className='col-8'>
                <span className='pl-1'>{order.communityName}</span>
              </div>
            </div>
            {orderPayments.map((item: any) => (
              <div>
                <div className='row pt-1'>
                  <div className='col-4'>
                    {item.paymentMode != 'coupon' &&
                      <span>Order total</span>
                    }
                    {item.paymentMode == 'coupon' &&
                      <span>Coupon Value</span>
                    }
                  </div>
                  <div className='col-8'>: <FxCurrency value={item.amount} /></div>
                </div>
                <div className='row pt-1'>
                  <div className='col-4'>Payment Mode</div>
                  <div className='col-8'>
                    <span>: </span>
                    <span>
                      {item.paymentMode == 'cod' &&
                        <span className="pr-1">Cash</span>
                      }
                      {item.paymentMode == 'stripe' &&
                        <span className="pr-1">Card</span>
                      }
                      {item.paymentMode != 'stripe' && item.paymentMode != 'cod' &&
                        <span className="pr-1 payment-style">{item.paymentMode}</span>
                      }
                    </span>
                  </div>
                </div>
                <div className='row pt-1'>
                  <div className='col-4'>
                    {item.paymentMode != 'coupon' &&
                      <span>Payment Status</span>
                    }
                    {item.paymentMode == 'coupon' &&
                      <span>Discount Status</span>
                    }
                  </div>
                  <div className='col-8'>
                    : <span>{item.paymentStatus}</span>
                  </div>
                </div>
              </div>
            ))}
            {deliverySlot &&
              <div className='row pt-1'>
                <div className='col-4'>
                  {order.orderTypeId === 1 &&
                    <span>Delivery</span>
                  }
                  {order.orderTypeId === 2 &&
                    <span>Pickup</span>
                  }
                </div>
                <div className='col-8'>: 
                  <span className='mr-2'> {general.getFormattedDate(order.orderDate)}</span>
                  {general.getFormattedTime(deliverySlot.startTime)} - {general.getFormattedTime(deliverySlot.endTime)}
                </div>
              </div>
            }
            {order.orderTypeId === 1 &&
              <div className='row pt-1'>
                <div className='col-4'>Delivery Address</div>
                <div className='col-8'>: {address.fullAddress}</div>
                <div className='col-4'>Location</div>
                {
                  address.locationName && 
                  <div className='col-8'>: {address.locationName ? address.locationName : ""}</div>
                }
              </div>
            }
            {order.orderTypeId === 2 &&
              <div className='row pt-1'>
                <div className='col-4'>Pickup Address</div>
                <div className='col-8'>: {order.stallAddress}</div>
              </div>
            }
            
            {/* Delivery Partner Information */}
            {order.orderTypeId === 1 && order.riderName && (
              <div className='row pt-1'>
                <div className='col-4'>Delivery Partner</div>
                <div className='col-8'>: {order.riderName}</div>
              </div>
            )}
            
            {order.orderTypeId === 1 && order.riderContact && (
              <div className='row pt-1'>
                <div className='col-4'>Partner Contact</div>
                <div className='col-8'>: {order.riderContact}</div>
              </div>
            )}
            
            {order.orderTypeId === 1 && order.statusCode && (
              <div className='row pt-1'>
                <div className='col-4'>Order Status</div>
                <div className='col-8'>: {order.statusCode}</div>
              </div>
            )}
            
            {order.orderTypeId === 1 && deliveryPartnerStatus && (
              <div className='row pt-1'>
                <div className='col-4'>Delivery Status</div>
                <div className='col-8'>: {deliveryPartnerStatus}</div>
              </div>
            )}
          </div>
          <div className='col-12 text-right pt-2'>
            {
              order.orderStatusId === 1 &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Accept</Button>
            }
            {
              (order.orderStatusId === 2 && order.orderTypeId === 1) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Ship</Button>
            }
            {
              (order.orderStatusId === 2 && order.orderTypeId === 2) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Ready</Button>
            }
            {
              (order.orderStatusId === 4 || order.orderStatusId === 5) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Deliver</Button>
            }
            {
              order.orderStatusId === 1 &&
              <Button variant='outlined' size='small' className='button-style ml-2' onClick={() => openConfirmDialogForCancel(order)}>Cancel</Button>
            }
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div className='mobileview'>
        <div className='mx-2 my-3 ml-0'>
          <div className='summary-detail font-13 mb-3'>
            <div className='row'>
              <div className='col-5'>Order #</div>
              <div className='col-7'>: {order.orderIdentifier}</div>
            </div>
            <div className='row pt-1'>
              <div className='col-5'>Ordered Date</div>
              <div className='col-7'>: {general.getFormattedDate(order.placedDate)}</div>
            </div>
            <div className='row pt-1'>
              <div className='col-5'>Consumer</div>
              <div className='col-7'>:
                <span className='pl-1'>{order.consumerName}</span>
                <span className='pl-3'>{order.consumerPhone}</span>
              </div>
            </div>
               <div className='row pt-1'>
              <div className='col-5'>Community</div>
              <div className='col-7'>
                <span className='pl-1'>{order.communityName}</span>
              </div>
            </div>
            {orderPayments.map((item: any) => (
              <div>
                <div className='row pt-1'>
                  <div className='col-5'>
                    {item.paymentMode != 'coupon' &&
                      <span>Order total</span>
                    }
                    {item.paymentMode == 'coupon' &&
                      <span>Coupon Value</span>
                    }
                  </div>
                  <div className='col-7'>: <FxCurrency value={item.amount} /></div>
                </div>
                <div className='row pt-1'>
                  <div className='col-5'>Payment Mode</div>
                  <div className='col-7'>
                    <span>: </span>
                    <span>
                      {item.paymentMode == 'cod' &&
                        <span className="pr-1">Cash</span>
                      }
                      {item.paymentMode == 'stripe' &&
                        <span className="pr-1">Card</span>
                      }
                      {item.paymentMode != 'stripe' && item.paymentMode != 'cod' &&
                        <span className="pr-1 payment-style">{item.paymentMode}</span>
                      }
                    </span>
                  </div>
                </div>
                <div className='row pt-1'>
                  <div className='col-5'>
                    {item.paymentMode != 'coupon' &&
                      <span>Payment Status</span>
                    }
                    {item.paymentMode == 'coupon' &&
                      <span>Discount Status</span>
                    }
                  </div>
                  <div className='col-7'>
                    : <span>{item.paymentStatus}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            {deliverySlot &&
              <div className='row pt-1'>
                <div className='col-5'>
                  {order.orderTypeId === 1 &&
                    <span>Delivery</span>
                  }
                  {order.orderTypeId === 2 &&
                    <span>Pickup</span>
                  }
                </div>
                <div className='col-7'>: 
                  <span className='mr-2'> {general.getFormattedDate(order.orderDate)}</span>
                  {general.getFormattedTime(deliverySlot.startTime)} - {general.getFormattedTime(deliverySlot.endTime)}
                </div>
              </div>
            }
            {order.orderTypeId === 1 &&
              <div className='row pt-1'>
                <div className='col-4'>Delivery Address</div>
                <div className='col-8'>: {address.fullAddress}</div>
                <div className='col-4'>Location</div>
                {
                  address.locationName && 
                  <div className='col-8'>: {address.locationName ? address.locationName : ""}</div>
                }
              </div>
            }
            {order.orderTypeId === 2 &&
              <div className='row pt-1'>
                <div className='col-5'>Pickup Address</div>
                <div className='col-7'>: {order.stallAddress}</div>
              </div>
            }
            
            {/* Delivery Partner Information */}
            {order.orderTypeId === 1 && order.riderName && (
              <div className='row pt-1'>
                <div className='col-5'>Delivery Partner</div>
                <div className='col-7'>: {order.riderName}</div>
              </div>
            )}
            
            {order.orderTypeId === 1 && order.riderContact && (
              <div className='row pt-1'>
                <div className='col-5'>Partner Contact</div>
                <div className='col-7'>: {order.riderContact}</div>
              </div>
            )}
            
            {order.orderTypeId === 1 && order.statusCode && (
              <div className='row pt-1'>
                <div className='col-5'>Order Status</div>
                <div className='col-7'>: {order.statusCode}</div>
              </div>
            )}
            
            {order.orderTypeId === 1 && deliveryPartnerStatus && (
              <div className='row pt-1'>
                <div className='col-5'>Delivery Status</div>
                <div className='col-7'>: {deliveryPartnerStatus}</div>
              </div>
            )}
          </div>

          <div>
            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
              <Table className="table-striped" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell >Items</TableCell>
                    <TableCell width={25}>Qty</TableCell>
                    <TableCell align="right" className='px-0'>Price</TableCell>
                    <TableCell width={100} align="right">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderLines.map((row: any) => (
                    <TableRow key={row.id}>
                      <TableCell className="table-font pr-0">
                        {row.itemName}
                        <div className='font-10 extras-txt'>
                          {row.orderLineModifiers && row.orderLineModifiers.map((custom, i) => (
                            <div>
                              <span>{custom.key}-</span>
                              {custom.displayModifiers && custom.displayModifiers.map((detail, idx) => (
                                <span>{detail.description}
                                  {idx != (custom.displayModifiers.length - 1) &&
                                    <span>, </span>
                                  }
                                  {i != (row.orderLineModifiers.length - 1) &&
                                    <span>, </span>
                                  }
                                </span>
                              ))}
                            </div>
                          ))}
                        </div>
                      </TableCell>
                      <TableCell className="table-font">
                        <span>{row.itemQuantity}</span>
                      </TableCell>
                      <TableCell align="right" className='px-0'>
                        <span className="table-font">
                          {row.itemQuantity} * <FxCurrency value={row.price} />
                          {row.lineModifierAmount > 0 &&
                            <span>+ <FxCurrency value={row.lineModifierAmount} /></span>
                          }
                        </span>
                      </TableCell>
                      <TableCell align="right">
                        <span className="table-font">
                          <FxCurrency value={row.lineTotalPrice} />
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell align="right" colSpan={3} className='px-0'>
                      <span className="table-font">Order Amount</span>
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.orderAmount} />
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="right" colSpan={3} className='px-0'>
                      <span className="table-font">Coupon Amount</span>
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.couponAmount} />
                      </span>
                    </TableCell>
                  </TableRow>
                  {
                    order.orderTypeId == 1 &&
                    <TableRow>
                      <TableCell align="right" colSpan={3} className='px-0'>
                        <span className="table-font">Delivery Charge</span>
                      </TableCell>
                      <TableCell align="right">
                        <span className="table-font">
                          <FxCurrency value={order.deliveryCharge} />
                        </span>
                      </TableCell>
                    </TableRow>
                  }
                  <TableRow>
                    <TableCell align="right" colSpan={3} className='px-0'>
                      {
                        order.orderTypeId == 1 &&
                        <span className="table-font">Total((Order Amount - Coupon Amount) + Delivery Charge)</span>
                      }
                      {
                        order.orderTypeId == 2 &&
                        <span className="table-font">Total(Order Amount - Coupon Amount)</span>
                      }
                    </TableCell>
                    <TableCell align="right">
                      <span className="table-font">
                        <FxCurrency value={order.orderTotal} />
                      </span>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
          <div className='col-12 text-right pt-3'>
            {
              order.orderStatusId === 1 &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Accept</Button>
            }
            {
              (order.orderStatusId === 2 && order.orderTypeId === 1) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Ship</Button>
            }
            {
              (order.orderStatusId === 2 && order.orderTypeId === 2) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Ready</Button>
            }
            {
              (order.orderStatusId === 4 || order.orderStatusId === 5) &&
              <Button variant='outlined' size='small' className='button-style' onClick={() => openConfirmDialogByStatus(order)}>Deliver</Button>
            }
            {
              order.orderStatusId === 1 &&
              <Button variant='outlined' size='small' className='button-style ml-2' onClick={() => openConfirmDialogForCancel(order)}>Cancel</Button>
            }
          </div>
        </div>
      </div>
      <Dialog
        open={confirmOpen}
        maxWidth="sm"
        fullWidth
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <ConfirmDialog message={message} handleDialogClose={handleDialogClose} onConfirmCallback={onConfirmCallback} action={isCancelAction ? "cancel" : ""} />
      </Dialog>
    </div>
  );

  return (
    <div>
      {body}
    </div>
  );

}

export default ProviderItemOrderDetail;